/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const chevronRight = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M10.6 6L9.4 7l4.6 5-4.6 5 1.2 1 5.4-6z" />
	</SVG>
);

export default chevronRight;
